import React, { useState } from 'react';
import { useTheme } from '../../ThemeContext';


export default function AddMemberPanel({
  userRole,
  onAddByWallet,
  onGenerateInvite,
  addingMember
}) {
  const { t, isDark } = useTheme();
  const [addMethod, setAddMethod] = useState('wallet');
  const [newWalletAddress, setNewWalletAddress] = useState('');
  const [newMemberRole, setNewMemberRole] = useState('admin');
  const [inviteRole, setInviteRole] = useState('admin');
  const [inviteMaxUses, setInviteMaxUses] = useState(1);
  const [inviteExpireDays, setInviteExpireDays] = useState(7);
  const [generatingInvite, setGeneratingInvite] = useState(false);

  const handleAddByWallet = async () => {
    await onAddByWallet(newWalletAddress, newMemberRole);
    setNewWalletAddress('');
    setNewMemberRole('admin');
  };

  const handleGenerateInvite = async () => {
    setGeneratingInvite(true);
    await onGenerateInvite(inviteRole, inviteMaxUses, inviteExpireDays);
    setGeneratingInvite(false);
  };

  return (
    <div style={{
      border: `1px solid ${t.borderStrong}`,
      borderRadius: '8px',
      padding: '20px',
      backgroundColor: t.surface,
      marginBottom: '24px'
    }}>
      {/* Method Tabs */}
      <div style={{
        display: 'flex',
        gap: '12px',
        marginBottom: '20px',
        borderBottom: '1px solid #e7e5e4',
        paddingBottom: '12px'
      }}>
        <button
          onClick={() => setAddMethod('wallet')}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: addMethod === 'wallet' ? t.buttonBg : 'transparent',
            color: addMethod === 'wallet' ? t.buttonText : t.text,
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'Poppins, sans-serif'
          }}
        >
          By Wallet Address
        </button>
        <button
          onClick={() => setAddMethod('invite')}
          style={{
            padding: '8px 16px',
            borderRadius: '6px',
            border: 'none',
            backgroundColor: addMethod === 'invite' ? t.buttonBg : 'transparent',
            color: addMethod === 'invite' ? t.buttonText : t.text,
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: '500',
            fontFamily: 'Poppins, sans-serif'
          }}
        >
          Generate Invite Link
        </button>
      </div>

      {/* Add by Wallet Address */}
      {addMethod === 'wallet' && (
        <div>
          <label style={{
            fontSize: '13px',
            fontWeight: '500',
            color: t.text,
            display: 'block',
            marginBottom: '6px',
            fontFamily: 'Poppins, sans-serif'
          }}>
            Wallet Address
          </label>
          <input
            type="text"
            value={newWalletAddress}
            onChange={(e) => setNewWalletAddress(e.target.value)}
            placeholder="addr1q..."
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              backgroundColor: t.surface,
              outline: 'none',
              marginBottom: '12px'
            }}
            onFocus={(e) => e.target.style.borderColor = t.accent}
            onBlur={(e) => e.target.style.borderColor = t.borderStrong}
          />

          <label style={{
            fontSize: '13px',
            fontWeight: '500',
            color: t.text,
            display: 'block',
            marginBottom: '6px',
            fontFamily: 'Poppins, sans-serif'
          }}>
            Role
          </label>
          <select
            value={newMemberRole}
            onChange={(e) => setNewMemberRole(e.target.value)}
            style={{
              width: '100%',
              padding: '12px',
              border: `1px solid ${t.borderStrong}`,
              borderRadius: '8px',
              fontSize: '14px',
              fontFamily: 'Poppins, sans-serif',
              backgroundColor: t.surface,
              outline: 'none',
              marginBottom: '16px'
            }}
            onFocus={(e) => e.target.style.borderColor = t.accent}
            onBlur={(e) => e.target.style.borderColor = t.borderStrong}
          >
            <option value="admin">Admin</option>
            <option value="guest">Guest</option>
            {userRole === 'primary_owner' && <option value="owner">Owner</option>}
          </select>

          <button
            onClick={handleAddByWallet}
            disabled={addingMember || !newWalletAddress.trim()}
            style={{
              width: '100%',
              backgroundColor: t.buttonBg,
              color: t.buttonText,
              padding: '12px',
              borderRadius: '12px',
              border: 'none',
              cursor: (addingMember || !newWalletAddress.trim()) ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              fontFamily: 'Poppins, sans-serif',
              opacity: (addingMember || !newWalletAddress.trim()) ? 0.5 : 1
            }}
          >
            {addingMember ? 'Adding...' : 'Add Member'}
          </button>
        </div>
      )}

      {/* Generate Invite Link */}
      {addMethod === 'invite' && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '16px' }}>
            <div>
              <label style={{
                fontSize: '13px',
                fontWeight: '500',
                color: t.text,
                display: 'block',
                marginBottom: '6px',
                fontFamily: 'Poppins, sans-serif'
              }}>
                Role
              </label>
              <select
                value={inviteRole}
                onChange={(e) => setInviteRole(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `1px solid ${t.borderStrong}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Poppins, sans-serif',
                  backgroundColor: t.surface,
                  outline: 'none'
                }}
              >
                <option value="admin">Admin</option>
                <option value="guest">Guest</option>
                {userRole === 'primary_owner' && <option value="owner">Owner</option>}
              </select>
            </div>

            <div>
              <label style={{
                fontSize: '13px',
                fontWeight: '500',
                color: t.text,
                display: 'block',
                marginBottom: '6px',
                fontFamily: 'Poppins, sans-serif'
              }}>
                Max Uses
              </label>
              <select
                value={inviteMaxUses}
                onChange={(e) => setInviteMaxUses(parseInt(e.target.value))}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `1px solid ${t.borderStrong}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Poppins, sans-serif',
                  backgroundColor: t.surface,
                  outline: 'none'
                }}
              >
                <option value="1">1</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="100">100</option>
              </select>
            </div>

            <div>
              <label style={{
                fontSize: '13px',
                fontWeight: '500',
                color: t.text,
                display: 'block',
                marginBottom: '6px',
                fontFamily: 'Poppins, sans-serif'
              }}>
                Expires
              </label>
              <select
                value={inviteExpireDays}
                onChange={(e) => setInviteExpireDays(parseInt(e.target.value))}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: `1px solid ${t.borderStrong}`,
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: 'Poppins, sans-serif',
                  backgroundColor: t.surface,
                  outline: 'none'
                }}
              >
                <option value="1">1 day</option>
                <option value="3">3 days</option>
                <option value="7">7 days</option>
                <option value="14">14 days</option>
                <option value="30">30 days</option>
              </select>
            </div>
          </div>

          <button
            onClick={handleGenerateInvite}
            disabled={generatingInvite}
            style={{
              width: '100%',
              backgroundColor: t.buttonBg,
              color: t.buttonText,
              padding: '12px',
              borderRadius: '12px',
              border: 'none',
              cursor: generatingInvite ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '600',
              fontFamily: 'Poppins, sans-serif',
              opacity: generatingInvite ? 0.5 : 1
            }}
          >
            {generatingInvite ? 'Generating...' : 'Generate Invite Link'}
          </button>
        </div>
      )}
    </div>
  );
}
